import React, { Component } from 'react'
import DisbursementRedraftForm from './components/DisbursementRedraftForm'
import { postDisbursement } from '../actions/disbursement.actions';
import { connect } from "react-redux";
import { Modal, ModalBody, Col, Card, CardBody } from "reactstrap";
import { MdArrowDownward } from 'react-icons/md';

class DisbursementRedraftFormView extends Component {

    state = {}

    redraftDisbursement = (value) => {
       
    };

    render() {
        return (
            <React.Fragment>
                <div>
                    <DisbursementRedraftForm
                        postDisbursement={this.props.postDisbursement}
                        onSubmit={this.redraftDisbursement}
                    />
                </div>
                <Modal isOpen={this.props.postDisbursement.loading} centered={true}>
                    <ModalBody>
                        <Col md={12} lg={12}>
                            <Card>
                                <CardBody style={{ textAlign: "center" }}>
                                    <div>
                                        <MdArrowDownward size={80} style={{ color: "#004266", marginTop: "2rem" }} className="vert-move" />
                                    </div>
                                    <br />
                                    <br />
                                    <div>
                                        <h5>Redraft Disbursement in progress...</h5>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </ModalBody>
                </Modal>
            </React.Fragment>
        )
    }
}

export default connect((state) => ({
    postDisbursement: state.postDisbursement
}))(DisbursementRedraftFormView);

